// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDT7q3Sz3QJHtK2skRa8Wyrczhp3YQdirQ",
  authDomain: "rbprj-100134.firebaseapp.com",
  projectId: "rbprj-100134",
  storageBucket: "rbprj-100134.appspot.com",
  messagingSenderId: "918236090013",
  appId: "1:918236090013:web:1ba21e1666bf07bd838e74",
  measurementId: "G-L9CJL7V7BC"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
